import { LOCATION_CHANGED } from '../ducks/routing.duck';

// Create a Redux middleware from the given analytics handlers. Each
// handler should have the following methods:
//
// - trackPageView(url): called when the URL is changed
export const createMiddleware = (handlers) => (store) => (next) => (action) => {
  const { type, payload } = action;
  if (type === LOCATION_CHANGED) {
    const { canonicalUrl, routeName } = payload;
    handlers.forEach((handler) => {
      handler.trackEvent(canonicalUrl, store, routeName);
    });
  }

  next(action);
};
